import { getCookie } from '@src/workflows/vs-standard-form/helpers/cache.helper';

export const loginEndPoint = '/mepa-api/app/v1/login';

export const DEFAULT_END_POINT = {
  standard: {
    default: '/mepa-api/app/v1/persistResponse',
    file: '/mepa-api/app/v1/persistResponseWithFile'
  },
  vces: {
    default: '/mepa-api/app/v1/vces/persistResponse',
    file: '/mepa-api/app/v1/vces/persistResponseWithFile'
  },
  vop: {
    default: '/mepa-api/app/v1//vop/enroll'
  },
  alp:{
    default: '/mepa-api/app/v1/ninedigitalp/submit'
  },
  vopreloadable: {
    default: '/mepa-api/app/v1/vop_reloadable/enroll'
  },
  unenrollvop: {
    default: '/mepa-api/app/v1/vop/unenroll'
  },
  redemption: {
    default: '/mepa-api/app/v1/redemptionResponse',
    file: '/mepa-api/app/v1/redemptionResponseWithFile'
  },
  authentication: {
    default: '/mepa-api/app/v1/authed/submission',
    file: '/mepa-api/app/v1/authed/submission/file'
  }
}

export type City = {
  value: string;
};

export type Country = {
  value: string;
  cityList: City[];
};

export type CountryCityList = {
  [key: string]: Country;
};

export type Club = {
  value: string;
};

export type CityClub = {
  city: string;
  clubList: Club[];
};

export type CityClubList = {
  [key: string]: CityClub;
};


export const isSkipCaptcha = 'isSkipCaptcha';
export const defaultEndPoint = '/mepa-api/app/v1/persistResponse';
export const defaultVCESValidationEndPoint = '/mepa-api/app/v1/vces/validate';
export const defaultFileApiEndPoint = '/mepa-api/app/v1/persistResponseWithFile';
export const vsfuSubmitEndPoint = '/mepa-api/app/v1/vsfu/vsfuResult/';

/* LIST of DEFAULTS */
export const defaultBaseUrl = 'https://qa.promotions.visa.com';
export const defaultGenericErrorMessage = 'Error, please try again later!';

export const defaultTokenMissingErrorMessage = 'Missing token, please provide a valid URL token to continue';
export const defaultSubmitButtonText = 'Submit';
export const defaultResetButtonText = 'Reset';
export const defaultSuccessMessage = 'Successfully submitted!'
export const defaultLoginError = 'There is an error with the API connection. Please try again later';

export const toExcludeAttribute = 'file';

export const AUTH_TYPE = 'GMAP';

export const defaultALPSuccess = {
  merchantUrl: '',
  cardNum: '',
  CardTypeCd: '',
  bin: '',
  binUrl: ''
}

export const getHeader = (xDataCenter, body, token = undefined,
                           isFile: boolean = false) => {
  let headers = isFile ? {
    'Authorization': token ? 'Bearer ' + token : undefined,
    'X-Datacenter': xDataCenter
  } : {
    'Content-Type': 'application/json',
    'Authorization': token ? 'Bearer ' + token : undefined,
    'X-Datacenter': xDataCenter
  }

  return {
    method: (!!body) ? 'POST' : 'GET',
    headers: headers,
    body: isFile ? (!!body ? body : undefined) : (body ? JSON.stringify(body) : undefined)
  };
};

export const ERROR_MESSAGES = {
  MONTHLY_COUNT_EXCEED: 'You have successfully verified for more than one times and no longer eligible for this offer'
}

// START GENAI@CHATGPT4
export const WORKFLOW = {
  ALP: 'alp',
  VOP: 'vop',
  UNENROLL_VOP: 'unenrollvop',
  STANDARD: 'standard',
  VCES: 'vces',
  REDEMPTION: 'redemption',
  VOP_RELOADABLE: 'vopreloadable',
  AUTHENTICATION: 'authentication',
  SENTOSA: 'sentosa',
  SENTOSA_CANCEL: 'sentosacancel'
}

export type WorkflowType = typeof WORKFLOW[keyof typeof WORKFLOW];

export function getApiEndPoints(workflow: WorkflowType) {
  let apiEndPoint = DEFAULT_END_POINT[workflow]?.default;
  let fileApiEndPoint = DEFAULT_END_POINT[workflow]?.file;

  if (!apiEndPoint) {
     apiEndPoint = defaultEndPoint;
  }

  if (!fileApiEndPoint) {
    fileApiEndPoint = defaultFileApiEndPoint;
  }

  return { apiEndPoint, fileApiEndPoint };
}
// END GENAI@CHATGPT4

// START GENAI@CHATGPT4
export const getAuthHeader = (xDataCenter: string, body: any, token = undefined,
                              isFile: boolean, authType: string) => {

  const header = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': isFile ? 'multipart/form-data' : 'application/json',
    'Authorization': 'Bearer ' + token,
    'X-Datacenter': xDataCenter,
    credentials: 'include',
    'Authorization-AUTHTYPE': authType
  };

  const gMAPToken = getCookie('gmap_auth');
  if(gMAPToken) {
    header['Authorization-AUTHTOKEN'] = `Bearer ${gMAPToken}`
  }

  return {
    method: 'POST',
    headers: header,
    body: body ? JSON.stringify(body) : undefined
  };
};
// END GENAI@CHATGPT4
